import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import { Col } from 'react-bootstrap';

import InfiniteScroll from 'react-infinite-scroller';

import AssetView from "./AssetView";

import ResponsiveHelper from 'src/legacy/services/responsive.helper.jsx';
import AssetDetailViewContainer from './AssetDetailViewContainer.jsx';

import styles from './AssetSearchResultView.module.scss';

class AssetSearchResultView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      hasMore: this.props.hasMore,
      expandedRow: -1,
      expandedDetailViewHeight: 300
    }
    this.handleHeight = this.handleHeight.bind(this);
  }

  loadMoreItems(){
    if(this.props.loadMore){
      this.props.loadMore();
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.hasMore != nextProps.hasMore){
      this.setState({
        hasMore: nextProps.hasMore
      });
    }
  }

  handleHeight(height){
      this.setState({
        expandedDetailViewHeight : height
      })
  }

  render() {
    return (
      <InfiniteScroll
        className={cx(styles.equalHeight, "row")}
        pageStart={0}
        initialLoad={false}
        hasMore={this.state.hasMore}
        loadMore={() => {this.loadMoreItems()}}
        useWindow = {false}
        threshold = {100}
        getScrollParent={() => this.props.containerRef && this.props.containerRef}
      >
        {this.renderItems()}
      </InfiniteScroll>
    );
  }

  renderItems(){
    var numberOfCells = this.getNumberOfCellsInGrid();
    var columns = 12 / numberOfCells;

    var items = this.props.items.map((item, index) => {  
      
      var selected = this.state.selectedAsset ? this.state.selectedAsset.id == item.id : false;

      return (
        <Col md={columns} key={ item.id }>
          <AssetView 
            id={ item.id } 
            asset={ item }
            index={ index } 
            selected={ selected }
            query = {this.props.query}
            recordSearchClick={this.props.recordSearchClick}
            onSelection={()=>{

              var row = Math.floor(index / numberOfCells) + 1;
              var previousSelectedAsset = this.state.selectedAsset;
              var selectedAsset = item;

              var toggleSelection = previousSelectedAsset ? previousSelectedAsset.id == selectedAsset.id : false;

              if(toggleSelection){
                row = -1;
                selectedAsset = null;
              }

              if(selectedAsset){
                this.props.fetchAssetDetail(selectedAsset);
              }

              this.setState({
                selectedAsset: selectedAsset,
                selectedIndex: index,
                expandedRow: row
              })
          }} />
        </Col>
      );
    });

    var numberOfRows = Math.ceil(this.props.items.length / numberOfCells);

    for (var i = 1; i <= numberOfRows; i++) {
      var row = i * numberOfCells + (i - 1);

      items.splice(row, 0, (
          <div 
            key={`details-row-${row}`} 
            style = {{height: (this.state.expandedRow == i) && this.state.expandedDetailViewHeight}}
            className={cx(styles.detailsDrawer, {[styles.expanded]: this.state.expandedRow == i})} 
            >

            {this.state.expandedRow == i && 
              <AssetDetailViewContainer 
                asset={this.state.selectedAsset} 
                index={this.state.selectedIndex}
                height = {this.handleHeight}
                query = {this.props.query}
              />
            }
            
          </div>
        )
      );
    }

    return items;
  }

  getNumberOfCellsInGrid(){
    var isMobile = ResponsiveHelper.isMobile(); 
    var isTablet = ResponsiveHelper.isTablet(); 
    var isTabletls = ResponsiveHelper.isTabletls(); 

    if(isMobile){
      return 1;
    }else if(isTablet){
      return 2;
    }else if(isTabletls){
      return 2;
    }

    return 3;
  }
}

export default AssetSearchResultView;